export default __webpack_public_path__ + "static/media/icon-check.fa179fe2.svg";